import React from 'react';
import { Input, Tooltip, Space } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

const tooltipContent = (
  <div>
    <p style={{ margin: 0 }}><b>Formato:</b> n&uacute;meros separados por comas</p>
    <p style={{ margin: 0 }}>Usa gui&oacute;n (-) para rangos (ej: 1-10)</p>
    <hr style={{ margin: '4px 0' }} />
    <p style={{ margin: 0 }}><b>Ejemplos:</b></p>
    <p style={{ margin: 0 }}>&bull; 1-7, 50, 150, 200-300</p>
    <p style={{ margin: 0 }}>&bull; 1, 2, 3, 4, 5</p>
    <p style={{ margin: 0 }}>&bull; 100-200</p>
  </div>
);

export const RangoEmpleadosLabel = () => (
  <Space size={4}>
    <span>Rango de Empleados</span>
    <Tooltip title={tooltipContent}>
      <InfoCircleOutlined style={{ color: 'rgba(0,0,0,0.45)' }} />
    </Tooltip>
  </Space>
);

const RangoEmpleadosInput = (props) => {
  const { placeholder = 'Ej: 1-7, 50, 150, 200-300', ...rest } = props;
  return (
    <Input
      placeholder={placeholder}
      {...rest}
    />
  );
};

export default RangoEmpleadosInput;
